import React, { useEffect, useRef } from 'react';
import { authStore } from '../../stores/authStore';

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      // ✅ Initialize immediately to reduce flicker
      authStore.initialize();
    }
  }, []);

  return <>{children}</>;
};

export default AuthProvider;